import { Component, OnInit } from '@angular/core';
//import { Camera } from ‘ionic-native’;
import { ActivatedRoute,Router,NavigationExtras } from '@angular/router';
import { PhotoLibrary } from '@ionic-native/photo-library/ngx';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { Meta, Title } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})


export class HomePage implements OnInit {
  private imageSrc: string;
  private images:any=[];
  demo=4;
  slideOpts = {
    initialSlide: 1,
    speed: 400
  };

  demo_items=[
    {
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402900/canales/BRODYS_LAB_aw15r0.jpg',
      title:'Hormigas Planas',
      descripcion:'¿Sabes cómo hacen las hormigas para comunicarse entre ellas y construir sus increíbles ciudades? Descúbrelo en este divertido corto animado.',
      video:'https://d2mtgsaet1zajn.cloudfront.net/Videos_Programas/videos+para+demo/R-CA-BL-02-EPISODIO+02+HORMIGAS.mp4',
   
    },
    {
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402415/podcast/1_ecrtdk.png',
      title:'Rosalind Franklin',
      descripcion:'¿Sabías que el ADN fue descubierto por una mujer?   ¡Averigua cómo fue, y qué más le   debemos a esta gran científica en este episodio de Cereal Box! ',
      
      video:'https://d2mtgsaet1zajn.cloudfront.net/Videos_Programas/videos+para+demo/RosaLinda_44_24.mp4',
   
    },
    {
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402893/canales/Happirits_copy_elfwaw.jpg',
      title:'Yoga en Parejas',
      descripcion:'En este capítulo de Happirits, Cris y Mariale te muestran cómo es posible hacer yoga con tu hermano, tu mejor amiga, o con alguno de tus papás.',
      
      video:'https://d2mtgsaet1zajn.cloudfront.net/Videos_Programas/videos+para+demo/HAP008+-+Episodio+8+Yoga+en+parejas.mp4',
      
    }
  ];
  slide_podcast=[
    {
      title:'Cereal Box',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402415/podcast/1_ecrtdk.png',
      text:'Acompaña tu desayuno con mágicos personajes que nos inspiran a luchar por nuestros sueños.'
    },
    {
      title:'Book Luv',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402415/podcast/2_swcoou.png',
      text:'Lecturas para ir a dormir con mucha inspiración, paz e imaginación.'
    },
    {
      title:'Gummy Rigg',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402416/podcast/4_ucgftu.png',
      text:'Descubre el mágico mundo de la animación, con las historias y recomendaciones de nuestros Animation Makers.'
    },
    {
      title:'Borreguitos',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,w_500/v1610403999/podcast/MEDITACIONES_PARA_DORMIR_ybfzwr.jpg',
      text:'Meditaciones para manejar nuestras emociones e ir a dormir en compañía de pensamientos positivos.'
    },
    {
      title:'Legacy',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610403851/podcast/legacy_cuekl5.png',
      text:'Cine, música, libros, viajes y todo lo que que heredamos de generación en generación en nuestra familia.'
    }
  ];
 
  slide_items=[
    {type:'yumyum',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402900/canales/YUM_YUM2_f1vudq.jpg',
      text:'Cocinarás cosas increíblemente deliciosas en Yum Yum.'
    },
    {
      type:'planetart',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,q_auto:good,w_500/v1610402895/canales/planetart_prv6ft.png',
      text:'Crearás grandes obras de arte para desarrollar tu talento.'
    },
    {
      type:'creeenti',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402896/canales/Cree_en_ti_za2mok.jpg',
      text:'Compartirás un espacio de sueños, imaginación y creatividad.'
    }
    ,
   /* {
      type:'clip',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402898/canales/clic_copy_uyg01a.jpg',
      text:' Tomarás grandes fotos y aprenderás mucho sobre tecnología.'
    }
    ,*/
    {
      type:'brodyslab',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402900/canales/BRODYS_LAB_aw15r0.jpg',
      text:'Realizarás mágicos experimentos científicos.'
    }
    ,
    {
      type:'wakeup',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402898/canales/WAKE_UP_gclhbz.jpg',
      text:'Activarás tu cuerpo para desarrollar fuerza y energía.'
    }
    ,
    {
      type:'happits',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_500,q_auto:good,w_500/v1610402893/canales/Happirits_copy_elfwaw.jpg',
      text:'Manejarás tus emociones en grandes clases de Yoga.'
    },
    {
      type:'misterybook',
      img:'https://res.cloudinary.com/woosycarl/image/upload/c_fill,h_1056,q_auto:eco,w_1065/v1611599202/canales/mistery_book_circular_mmk0tl.jpg',
      text:'Descubrirás los misterios más impresionantes de la historia.'
    },    
  ]
  constructor(private photoLibrary: PhotoLibrary,
    public meta: Meta, public title: Title,
    private routerT: Router,
    private imagePicker: ImagePicker,
    private storage: Storage) { }
//private photoLibrary: PhotoLibrary
  ngOnInit() {
    this.getStore();
    this.meta.updateTag({ name: 'description', content: 'Plataforma de entretenimiento familiar para aprender de forma segura, divertida y emocionante.' }); 
this.title.setTitle('Woosy');
  }

  async getStore() {
    //this.storage.remove('user');
    let item = null;
    await this.storage.get('user').then((val) => {
      item = val;
      console.log("item2");
      //console.log(val)
      if (item == undefined) {
        //this.routerT.navigateByUrl('/suscribete')
      }
      else{
        if(item.hasOwnProperty('is_premium')&&item.is_premium){

          if(item.hasOwnProperty('rolid'))
          {
            if(item.rolid == 2){
              this.routerT.navigateByUrl('/welcome')
            }else if(item.rolid == 1){
               this.routerT.navigateByUrl('/app/dash')
             }
            
          }else if(item.users.hasOwnProperty('rolid'))
          {
           
            if(item.users.rolid == 2){
              this.routerT.navigateByUrl('/welcome')
            }else if(item.users.rolid == 1){
               this.routerT.navigateByUrl('/app/dash')
             }

          }
        
        
          
        
        
          }else{

            if(item.hasOwnProperty('rolid'))
            {
  
              if(item.rolid == 2){
                this.routerT.navigateByUrl('/dash')
              }else if(item.rolid == 1){
                this.routerT.navigateByUrl('/app/dash')
              }
              
            }else if(item.users.hasOwnProperty('rolid'))
            {

              if(item.users.rolid == 2){
                this.routerT.navigateByUrl('/dash')
              }else if(item.users.rolid == 1){
                this.routerT.navigateByUrl('/app/dash')
              }
             
            }


        }
      }
    });
  }


  navidateTop(type){
  
    this.routerT.navigateByUrl('/canales?type='+type)
  }
  navidateCortos(){
  
    this.routerT.navigateByUrl('/cortosanimados')
  }
  navidateAnimation(){
  
    this.routerT.navigateByUrl('/animationmakers')
  }
 /* private openGallery (): void {
    let cameraOptions = {
      sourceType: Camera.PictureSourceType.PHOTOLIBRARY,
      destinationType: Camera.DestinationType.FILE_URI,      
      quality: 100,
      targetWidth: 1000,
      targetHeight: 1000,
      encodingType: Camera.EncodingType.JPEG,      
      correctOrientation: true
    }
  
    Camera.getPicture(cameraOptions)
      .then(file_uri => this.imageSrc = file_uri, 
      err => console.log(err));   
  }*/
  suscribete(){
    this.routerT.navigateByUrl('/suscribete')
  }
  demoShow(i){
    console.log(i)
this.demo=i;
  }
async getpicture(){
  let options = {
    // Android only. Max images to be selected, defaults to 15. If this is set to 1, upon
    // selection of a single image, the plugin will return it.
    maximumImagesCount: 5,
    
    // max width and height to allow the images to be.  Will keep aspect
    // ratio no matter what.  So if both are 800, the returned image
    // will be at most 800 pixels wide and 800 pixels tall.  If the width is
    // 800 and height 0 the image will be 800 pixels wide if the source
    // is at least that wide.
    width: 200,
    height: 200,
    
    // quality of resized image, defaults to 100
    quality: 100,

    // output type, defaults to FILE_URIs.
    // available options are 
    // window.imagePicker.OutputType.FILE_URI (0) or 
    // window.imagePicker.OutputType.BASE64_STRING (1)
    outputType: 1
};
  this.imagePicker.getPictures(options).then((results) => {
    for (var i = 0; i < results.length; i++) {
        console.log('Image URI: ' + results[i]);
        this.images.push('data:image/jpeg;base64,' + results[i])
    }
  }, (err) => { });
/*
   await this.photoLibrary.requestAuthorization().then(() => {
    this.photoLibrary.getLibrary().subscribe({
      next: library => {
        library.forEach(function(libraryItem) {
          console.log(libraryItem.id);          // ID of the photo
          console.log(libraryItem.photoURL);    // Cross-platform access to photo
          console.log(libraryItem.thumbnailURL);// Cross-platform access to thumbnail
          console.log(libraryItem.fileName);
          console.log(libraryItem.width);
          console.log(libraryItem.height);
          console.log(libraryItem.creationDate);
          console.log(libraryItem.latitude);
          console.log(libraryItem.longitude);
          console.log(libraryItem.albumIds);    // array of ids of appropriate AlbumItem, only of includeAlbumsData was used
        });
      },
      error: err => { console.log('could not get photos'); },
      complete: () => { console.log('done getting photos'); }
    });
  })
  .catch(err => console.log('permissions weren\'t granted'));
  alert(20)
}*/
}



}
